// extracted by mini-css-extract-plugin
export default {"heading":"_2uN6h","text":"_1e7Pw"};